import type { IGroup } from '../../interfaces/group';
import { translateKey } from '../../../translate';

export function GroupBlock(props: { group: IGroup }) {
    return (
        <ul>
            <li>
                {translateKey('common.name')}: {props.group.name}
            </li>
            <li>
                {translateKey('common.isActive')}:{' '}
                {props.group.isActive ? translateKey('common.yes') : translateKey('common.no')}
            </li>
        </ul>
    );
}
